// Super Admin "Log in as customer" (support mode) helpers.
// The admin's own session is stashed in imp_admin_* keys while the short-lived
// impersonation token takes over the normal `token` / `user` keys.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STASH_KEYS = [
  "imp_admin_token", "imp_admin_refresh", "imp_admin_user",
  "imp_log_id", "imp_expires_at", "imp_customer_name",
];

export function getImpersonationState() {
  const adminToken = localStorage.getItem("imp_admin_token");
  if (!adminToken) return { active: false };
  return {
    active: true,
    customerName: localStorage.getItem("imp_customer_name") || "customer",
    expiresAt: localStorage.getItem("imp_expires_at"),
    logId: localStorage.getItem("imp_log_id"),
  };
}

export async function startImpersonation(targetUser) {
  const adminToken = localStorage.getItem("token");
  const res = await axios.post(
    `${API}/admin/users/${targetUser.user_id}/impersonate`, {},
    { headers: { Authorization: `Bearer ${adminToken}` } }
  );
  // Stash the admin session so we can switch back without re-login
  localStorage.setItem("imp_admin_token", adminToken);
  const rt = localStorage.getItem("refresh_token");
  if (rt) localStorage.setItem("imp_admin_refresh", rt);
  const au = localStorage.getItem("user");
  if (au) localStorage.setItem("imp_admin_user", au);
  localStorage.setItem("imp_log_id", res.data.log_id);
  localStorage.setItem("imp_expires_at", res.data.expires_at);
  localStorage.setItem("imp_customer_name", res.data.user?.name || res.data.user?.email || "customer");
  // Switch the active session to the customer (no refresh token on purpose —
  // the impersonation token must hard-expire after 60 minutes)
  localStorage.setItem("token", res.data.token);
  localStorage.removeItem("refresh_token");
  localStorage.setItem("user", JSON.stringify(res.data.user));
  localStorage.setItem("auth_kind", "owner");
  window.location.href = "/dashboard";
}

export async function exitImpersonation() {
  const adminToken = localStorage.getItem("imp_admin_token");
  const logId = localStorage.getItem("imp_log_id");
  if (adminToken && logId) {
    try {
      await axios.post(`${API}/admin/impersonation/${logId}/end`, {},
        { headers: { Authorization: `Bearer ${adminToken}` } });
    } catch { /* log stays open until expiry — restore session regardless */ }
  }
  if (adminToken) localStorage.setItem("token", adminToken);
  const rt = localStorage.getItem("imp_admin_refresh");
  if (rt) localStorage.setItem("refresh_token", rt);
  const au = localStorage.getItem("imp_admin_user");
  if (au) localStorage.setItem("user", au);
  localStorage.setItem("auth_kind", "owner");
  STASH_KEYS.forEach((k) => localStorage.removeItem(k));
  window.location.href = "/admin/users";
}
